import { render } from "./Tag.vue?vue&type=template&id=ebab6fc0&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=ebab6fc0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ebab6fc0"

export default script